import toast from "react-hot-toast";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
export async function exportToExcel(exportedData) {
  try {
    let result = exportedData.data;
    let filteredDetails = exportedData.filterDetails;

    // Create a new workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    // Merge cells for the header
    worksheet.mergeCells("A1:J1"); // Merge the first row across 21 columns (A to T)

    // Add and style the header
    const headerCell = worksheet.getCell("A1");
    headerCell.value = "Damas";
    headerCell.font = {
      bold: true,
      color: { argb: "00000000" },
      size: 32,
    };
    headerCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFFFFFFF" },
    };
    headerCell.alignment = { horizontal: "center", vertical: "middle" };
    worksheet.getRow(1).height = headerCell.font.size * 1.2;

    // define the next row
    let nextRow = 2;

    if (filteredDetails && Array.isArray(filteredDetails)) {
      const relevantKeys = filteredDetails.filter((item) =>
        ["status", "tripRoute"].includes(item.key)
      );

      if (relevantKeys.length > 0) {
        // Handle case with two columns
        if (relevantKeys.length === 2) {
          worksheet.mergeCells("A" + nextRow + ":E" + nextRow); // Merge first half
          worksheet.mergeCells("F" + nextRow + ":J" + nextRow); // Merge second half

          const headerCellA = worksheet.getCell("A" + nextRow);
          headerCellA.value = `${relevantKeys[0].key.charAt(0).toUpperCase() +
            relevantKeys[0].key.slice(1)
            }: ${relevantKeys[0].value === "driver"
              ? "Accepted"
              : relevantKeys[0].value.charAt(0).toUpperCase() +
              relevantKeys[0].value.slice(1)
            }`; // Set value for first column
          headerCellA.font = {
            bold: true,
            color: { argb: "00000000" },
            size: 20,
            family: "Cambria",
          };

          headerCellA.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFFFFFF" },
          };
          headerCellA.text.charAt(0).toUpperCase();

          const headerCellF = worksheet.getCell("F" + nextRow);
          // headerCellF.value = `${relevantKeys[0].key}: ${relevantKeys[0].value}`; // Set value for first column ${relevantKeys[1].value}`; // Set value for first column

          headerCellF.value = `${relevantKeys[1].key.charAt(0).toUpperCase() +
            relevantKeys[1].key.slice(1)
            }: ${relevantKeys[1].value === "driver"
              ? "Accepted"
              : relevantKeys[1].value.charAt(0).toUpperCase() +
              relevantKeys[1].value.slice(1)
            }`;

          headerCellF.font = {
            bold: true,
            color: { argb: "00000000" },
            size: 14,
            family: "Calibri",
          };
          headerCellF.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFFFFFF" },
          };
          headerCellF.text.charAt(0).toUpperCase();

          worksheet.getRow(nextRow).height = headerCellA.font.size * 1.2; // Adjust row height
          // worksheet.getRow(nextRow).border = {
          //   top: { style: "medium" },
          //   bottom: { style: "medium" },
          // };

          // Increment nextRow for subsequent data
        } else {
          // Handle case with more than two columns (merge all)
          worksheet.mergeCells("A" + nextRow + ":J" + nextRow);
          const headerCellA = worksheet.getCell("A" + nextRow);

          headerCellA.value = `${relevantKeys[0].key.charAt(0).toUpperCase() +
            relevantKeys[0].key.slice(1)
            }: ${relevantKeys[0].value === "driver"
              ? "Accepted"
              : relevantKeys[0].value.charAt(0).toUpperCase() +
              relevantKeys[0].value.slice(1)
            }`; // Or dynamically construct a header based on all keys, first char uppercase

          headerCellA.font = {
            bold: true,
            color: { argb: "00000000" },
            size: 14,
            family: "Calibri",
          };
          headerCellA.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFFFFFF" },
          };

          headerCellA.text.charAt(0).toUpperCase();
          worksheet.getRow(nextRow).height = headerCellA.font.size * 1.2;
          // worksheet.getRow(nextRow).border = {
          //   top: { style: "medium" },
          //   bottom: { style: "medium" },
          // };
        }
        nextRow++;
      }
    }

    // Add and style the column headers
    worksheet.addRow([
      "Sl.",
      "Order ID",
      "T.O/ST",
      "Bag No.",
      "Booking",
      "From",
      "To",
      "Name",
      "Signature",
      "E Code",
    ]);
    // worksheet.addRow([
    //   "Sl.",
    //   "OrderId",
    //   "FromLocation",
    //   "ToLocation",
    //   "Pick Date",
    //   "Pickup Time",
    //   "SealBag",
    //   "Remarks",
    //   "TransferOrderNo",
    //   "Created Date",
    //   "Created By",
    //   "Accept or Rejected By",
    //   "Trip Created By",
    //   "Vechicle Id",
    //   "Route Name",
    //   "Route Code",
    //   "Trip Driver",
    //   "Status",
    //   "Priority",
    //   "Country",
    // ]);

    worksheet.columns.forEach((column) => {
      if (column.letter === "A") {
        column.width = 5;
      }
      if (/^[B-T]$/.test(column.letter)) {
        // Set width for column B to R
        column.width = 25;
      }
    });

    const secondTitlRow = worksheet.getRow(nextRow);
    secondTitlRow.eachCell((cell) => {
      cell.font = { bold: true, family: "Calibri", size: 11 };
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });

    // Add data

    result.forEach((element, index) => {
      const rowData = [
        index + 1,
        element.bookingOrderId,
        element.transferOrderNo,
        element?.sealBag?.serialNo,
        element.status === "driver" ? "Accepted" : element.status,
        element?.fromLocation?.name,
        element?.toLocation?.name,
        "",
        "",
        "",
      ];
      worksheet.addRow(rowData);
    });

    // result.forEach((element, index) => {
    //   const rowData = [
    //     index + 1,
    //     element.bookingOrderId,
    //     element?.fromLocation?.name,
    //     element?.toLocation?.name,
    //     element?.pickupDate,
    //     element?.pickupTime,
    //     element?.sealBag?.serialNo,
    //     element?.remarks,
    //     element.transferOrderNo,
    //     moment(element.createdAt).format("YYYY-MM-DD HH:mm:ss"),
    //     element.createdBy
    //       ? `${element?.createdBy?.firstName} ${element?.createdBy?.lastName}`
    //       : "",
    //     element.orderAcceptRejectById
    //       ? `${element?.orderAcceptRejectById?.firstName} ${element?.orderAcceptRejectById?.lastName}`
    //       : "",
    //     element?.tripAssignedBy
    //       ? `${element?.tripAssignedBy?.firstName} ${element?.tripAssignedBy?.lastName}`
    //       : "",
    //     element?.tripVehicleId,
    //     element?.tripRoute?.name,
    //     element?.tripRoute?.routeCode,
    //     element?.tripAssignedTo
    //       ? `${element?.tripAssignedTo?.firstName} ${element?.tripAssignedTo?.lastName}`
    //       : "",
    //     element.status,
    //     element.priority ? element.priority : "normal",
    //     element?.country?.name,
    //   ];
    //   worksheet.addRow(rowData);
    // });

    // Add borders to the data cells
    worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        // cell.font = {
        //   family: "Cambria",
        //   bold: false,
        //   size: 12,
        // };
      });
    });

    // Write workbook to a buffer
    const buffer = await workbook.xlsx.writeBuffer();

    // Save the buffer as a file
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "Booking-Order.xlsx");

    toast.dismiss();
  } catch (error) {
    toast.dismiss();
    console.error(error);
  }
}
